module.exports = __webpack_public_path__ + "img/cn.c52ac962.png";